export enum PrimitiveModel3dType {
  Cube = 'cube',
  Plane = 'plane',
  Sphere = 'sphere'
}
